import { Routes, Route, Navigate } from "react-router-dom";
import CreateCatalog from "../pages/createCatalog";
import Dashboard from "../pages/dashboard.js";
import Analytics from "../pages/analytics.js";
import Files from "../pages/files.js";
import Products from "../pages/products.js";
import PrivateRoute from "../config/protectedRoute.js";
import { useUser } from "../config/userProvider.js";
import ForgetPassword from "../pages/forgetPassword.js";
import UserLogin from "../pages/userLogin.js";
import Account from "../pages/account.js";
import Celebration from "../pages/celebration.js";
import ImageEditor from "../pages/ImageEditor.js";
import Integration from "../pages/integration.js";
import Offers from "../pages/offers.js";
import Stores from "../pages/stores.js";
import Broadcasts from "../pages/broadcasts.js";
import Teams from "../pages/teams.js";
import Catalogues from "../pages/catalogues.js";
import Customers from "../pages/customers.js";
import OfferDetails from "../pages/offerDetails.js";
import Apps from "../pages/apps.js";
import AppDetails from "../pages/appDetails.js";
import AddTeam from "../pages/addTeam.js";
import AddStore from "../pages/addStore.js";
import EditTeam from "../pages/editTeam.js";
import NotFound from "../pages/notFound.js";
import EditStore from "../pages/editStore.js";
import StoreDetails from "../pages/storeDetails.js";
import TeamDetails from "../pages/teamDetails.js";
import AddCustomer from "../pages/addCustomer.js";
import EditCustomer from "../pages/editCustomer.js";
import CustomerDetails from "../pages/customerDetails.js";
import ProductDetails from "../pages/productDetails.js";
import CreateApp from "../pages/createApp.js";
import AddProduct from "../pages/addProduct.js";
import Orders from "../pages/orders.js";
import CreateBroadcast from "../pages/createBroadcast.js";
import CreateOffer from "../pages/createOffer.js";
import Leaderboard from "../pages/leaderboard";
import UpdatePassword from "../pages/updatePassword.js";
import AnalyticsReport from "../pages/analyticsReport";
import Vendors from "../pages/vendors";
import Support from "../pages/support";
import VendorDetails from "../pages/vendorDetails.js";
import CreateTicket from "../pages/createTicket.js";
import Demos from "../pages/demos.js";
import Tickets from "../pages/tickets.js";
import TicketList from "../pages/ticketList.js";
import TicketManage from "../pages/ticketManage.js";
import Segments from "../pages/segments.js";
import Insight from "../pages/insight.js";
import Loyalty from "../pages/loyalty.js";
import VendorCreate from "../pages/vendorCreate.js";
import Appearance from "../pages/appearance.js";
import Documents from "../pages/documents.js";
import Myplan from "../pages/myplan.js";
import MyPlan from "../pages/myplan.js";
import Unauthorized from "../pages/unauthorized";
import CreateSegment from "../pages/createSegment.js";
import SegmentDetails from "../pages/segmentDetails.js";
import TicketDetails from "../pages/ticketDetails.js";
import Chat from "../pages/chat.js";
// import Setting from "../pages/setting.js";
// import Home from "../pages/home";
// import Dashboard from "../pages/dashboard";
// import Createuser from "../pages/createuser.js";
// import Viewuser from "../pages/viewuser.js";
// import Viewstore from "../pages/stores.js";
// import { useContext, useEffect, useState } from "react";
// import CreateCatalog2 from "../pages/createCatlog2";
// import StoreDateWise from "../components/storeDateWise";
// import Login from "../pages/home";
// import { validateToken } from "../config/validateToken.js";
// import { getCookie } from "../config/webStorage.js";
// import PdfTemplate from "../pages/catalogues.js";
// import Team from "../pages/teams.js";
// import UserPermissions from "../config/userPermissions.js"


const Router = () => {
  const { userData } = useUser();
  console.log("userData 33 routes page", userData);
  return (
    <Routes>
      <Route path="/" element={<UserLogin />} />
      <Route path="/forgetpassword" element={<ForgetPassword />} />
      <Route
        path="/updatepassword/:userObjId/:updatePasswordToken"
        element={<UpdatePassword />}
      />

      <Route path="/account" element={<PrivateRoute element={<Account />} />} />
      {/* <Route
          path="/admin"
          element={<PrivateRoute element={<AdminLogin />} />}
        /> */}

      <Route
        path="/dashboard"
        element={<PrivateRoute element={<Dashboard />} />}
      />
      <Route
        path="/vendors/registration"
        element={<PrivateRoute element={<VendorCreate />} />}
      />

      <Route
        path="/createcatalog"
        element={<PrivateRoute element={<CreateCatalog />} />}
      />
      <Route
        path="/imageeditor"
        element={<PrivateRoute element={<ImageEditor />} />}
      />
      <Route path="/myplan" element={<PrivateRoute element={<Myplan />} />} />
      <Route path="/chat" element={<PrivateRoute element={<Chat />} />} />
      {/* <Route
                path="/dashboard"
                element={<PrivateRoute element={<Dashboard />} />}
              /> */}
      {/* <Route
          path="/createuser"
          element={<PrivateRoute element={<Createuser />} />}
        /> */}
      {/* <Route
          path="/viewuser"
          element={<PrivateRoute element={<Viewuser />} />}
        /> */}
      <Route path="/stores" element={<PrivateRoute element={<Stores />} />} />
      <Route
        path="/stores/add"
        element={<PrivateRoute element={<AddStore />} />}
      />
      <Route
        path="/stores/:storeId/edit"
        element={<PrivateRoute element={<EditStore />} />}
      />
      <Route
        path="/stores/:storeId"
        element={<PrivateRoute element={<StoreDetails />} />}
      />

      <Route
        path="/analytics"
        element={<Navigate to="/analytics/overview" replace />}
      />
      <Route
        path="/analytics/overview"
        element={<PrivateRoute element={<Analytics />} />}
      />
      <Route
        path="/analytics/report"
        element={<PrivateRoute element={<AnalyticsReport />} />}
      />
      <Route
        path="/analytics/leaderboard"
        element={<PrivateRoute element={<Leaderboard />} />}
      />
      <Route
        path="/analytics/insights"
        element={<PrivateRoute element={<Insight />} />}
      />
      {/* <Route
          path="/storedatewise"
          element={<PrivateRoute element={<StoreDateWise />} />}
        /> */}
      <Route path="/files" element={<PrivateRoute element={<Files />} />} />
      <Route
        path="/products"
        element={<PrivateRoute element={<Products />} />}
      />
      <Route
        path="/products/add"
        element={<PrivateRoute element={<AddProduct />} />}
      />
      <Route
        path="/products/:productId"
        element={<PrivateRoute element={<ProductDetails />} />}
      />
      <Route
        path="/ticketdetails/:ticketId"
        element={<PrivateRoute element={<TicketDetails />} />}
      />
      <Route
        path="/catalogues"
        element={<PrivateRoute element={<Catalogues />} />}
      />
      <Route
        path="/celebration"
        element={<PrivateRoute element={<Celebration />} />}
      />
      <Route path="/apps" element={<PrivateRoute element={<Apps />} />} />
      <Route
        path="/integration"
        element={<PrivateRoute element={<Integration />} />}
      />
      <Route path="/teams" element={<PrivateRoute element={<Teams />} />} />
      <Route
        path="/teams/add"
        element={<PrivateRoute element={<AddTeam />} />}
      />
      <Route
        path="/teams/:userObjId"
        element={<PrivateRoute element={<TeamDetails />} />}
      />
      <Route
        path="/teams/:userObjId/edit"
        element={<PrivateRoute element={<EditTeam />} />}
      />
      <Route path="/offers" element={<PrivateRoute element={<Offers />} />} />
      <Route
        path="/offers/create"
        element={<PrivateRoute element={<CreateOffer />} />}
      />
      <Route
        path="/offers/:id"
        element={<PrivateRoute element={<OfferDetails />} />}
      />
      <Route
        path="/broadcasts"
        element={<PrivateRoute element={<Broadcasts />} />}
      />
      <Route path="/loyalty" element={<PrivateRoute element={<Loyalty />} />} />
      <Route
        path="/broadcasts/create"
        element={<PrivateRoute element={<CreateBroadcast />} />}
      />
      <Route
        path="/customers"
        element={<Navigate to="/customers/all" replace />}
      />
      <Route
        path="/customers/all"
        element={<PrivateRoute element={<Customers />} />}
      />
      <Route
        path="/customers/create"
        element={<PrivateRoute element={<AddCustomer />} />}
      />
      <Route
        path="/customers/view/:customerObjId"
        element={<PrivateRoute element={<CustomerDetails />} />}
      />
      <Route
        path="/customers/edit/:customerObjId"
        element={<PrivateRoute element={<EditCustomer />} />}
      />
      <Route
        path="/customers/segments"
        element={<PrivateRoute element={<Segments />} />}
      />
      <Route
        path="/customers/segments/create"
        element={<PrivateRoute element={<CreateSegment />} />}
      />
      <Route
        path="/customers/segments/:segmentObjId"
        element={<PrivateRoute element={<SegmentDetails />} />}
      />

      <Route
        path="/apps/create"
        element={<PrivateRoute element={<CreateApp />} />}
      />
      <Route
        path="/apps/:id"
        element={<PrivateRoute element={<AppDetails />} />}
      />
      <Route path="/orders" element={<PrivateRoute element={<Orders />} />} />
      <Route
        path="/leaderboard"
        element={<PrivateRoute element={<Leaderboard />} />}
      />
      <Route path="/orders" element={<PrivateRoute element={<Orders />} />} />
      <Route path="/vendors" element={<PrivateRoute element={<Vendors />} />} />
      <Route
        path="/vendors/:vendorObjId"
        element={<PrivateRoute element={<VendorDetails />} />}
      />
      <Route path="/demos" element={<PrivateRoute element={<Demos />} />} />
      <Route path="/support" element={<PrivateRoute element={<Support />} />} />
      <Route
        path="/support/tickets"
        element={<PrivateRoute element={<Tickets />} />}
      />
      <Route
        path="/support/ticketslist"
        element={<PrivateRoute element={<TicketList />} />}
      />
      <Route
        path="/support/ticketslist/:id/manage"
        element={<PrivateRoute element={<TicketManage />} />}
      />
      {/* <Route
          path="/settings"
          element={<PrivateRoute element={<Setting />} />}
        /> */}
      <Route
        path="/settings"
        element={<Navigate to="/settings/documents" replace />}
      />
      <Route
        path="/settings/documents"
        element={<PrivateRoute element={<Documents />} />}
      />
      <Route
        path="/settings/appearance"
        element={<PrivateRoute element={<Appearance />} />}
      />
      <Route
        path="/settings/myplan"
        element={<PrivateRoute element={<MyPlan />} />}
      />
      <Route
        path="/support/tickets/create"
        element={<PrivateRoute element={<CreateTicket />} />}
      />
      {/* <Route
          path="/stores"
          element={<PrivateRoute element={<Stores />} />}
        /> */}
      {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Router;
